import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'
import { Provider as AlertProvider } from 'react-alert'
import { CssBaseline, ThemeProvider } from '@mui/material'

import './main.css'
import App from './App'
import './fonts/fonts.css'
import theme from './theme'
import { store, history } from './store'
import SystemAlert from './components/SystemAlert/SystemAlert'

ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />

			<Provider store={store}>
				<AlertProvider
					template={SystemAlert}
					timeout={8000}
					transition={'fade'}
					offset={'100px'}
					containerStyle={{
						zIndex: 1400,
					}}
				>
					<App history={history} />
				</AlertProvider>
			</Provider>
		</ThemeProvider>
	</React.StrictMode>,
	document.getElementById('root')
)
